import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AuthContext from '../context/AuthContext';
import { SUPPORTED_TIMEZONES } from '../constants/timezones';

/**
 * Header control for the user's timezone. Every date-time in the app is
 * rendered, and every created_at filter is resolved, in the zone chosen here.
 */
const TimezoneSelector = () => {
  const { t } = useTranslation();
  const { timezone, setTimezone } = useContext(AuthContext);

  return (
    <select
      aria-label={t('common.timezone')}
      className="form-select-sm"
      value={timezone}
      onChange={(e) => setTimezone(e.target.value)}
    >
      {SUPPORTED_TIMEZONES.map((zone) => (
        <option key={zone.value} value={zone.value}>
          {t(zone.labelKey)}
        </option>
      ))}
    </select>
  );
};

export default TimezoneSelector;
